import StoneDataTableColumn from './stone-data-table-column.vue'
export default StoneDataTableColumn
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('stone-data-table-column', StoneDataTableColumn)
}



// WEBPACK FOOTER //
// ./src/components/stone-data-table-column/index.js